import { IncidentsDashboard } from "@/features/dashboard/incidents-dashboard";

export const Route = createFileRoute({
  component: IncidentsDashboard,
});
